import type {
  CompliancePolicy,
  CompliancePolicyListInput,
  CompliancePolicyListSuccess,
  WithArchivedFilter,
} from '@terros/common'
import type { GetHookResponse } from '../../hooks'
import { compliancePoliciesKey } from '../../keys'
import { useTantalimQuery } from '../../query'

export function useCompliancePolicies({ archived = false }: WithArchivedFilter): GetHookResponse<CompliancePolicy[]> {
  return useTantalimQuery<CompliancePolicyListInput, CompliancePolicyListSuccess, CompliancePolicy[]>({
    url: '/compliance/policy/list',
    queryKey: compliancePoliciesKey(archived),
    input: {
      archived,
    },
    convertResponse: (data) => data.policies,
  })
}
